import { AppStartUpImpl } from "../data/AppStartUpImpl";
import { IAppStartUpRepository } from "../domain/repositories/IAppStartUpRepository";
import { AppStartUpUseCase } from "../domain/useCases/AppStartUpUseCase";
import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";

export class AppStartUpInjection extends InjectionModule {
  private static readonly appStartUpRepositoryToken = Symbol(
    "IAppStartUpRepository",
  );
  private static readonly appStartUpUseCaseToken = Symbol("AppStartUpUseCase");

  protected static override bindings: InjectionBinding[] = [
    {
      scope: "otherRepo",
      token: this.appStartUpRepositoryToken,
      useClass: AppStartUpImpl,
    },
    {
      scope: "otherRepo",
      token: this.appStartUpUseCaseToken,
      useClass: AppStartUpUseCase,
    },
  ];

  static getRepo(): IAppStartUpRepository {
    return this.resolve(this.appStartUpRepositoryToken);
  }

  static getUseCase(): AppStartUpUseCase {
    return this.resolve(this.appStartUpUseCaseToken);
  }
}
